import { Route } from 'src/routes/Route'

export const ShareSettingsRoute = Route({ path: '/sharing-settings' })
export type ShareSettingsRoute = Route<typeof ShareSettingsRoute>
